import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import srLogin from "../locales/sr/login.json";
import enLogin from "../locales/en/login.json";

const savedLanguage = localStorage.getItem("appLanguage");
const initialLanguage = savedLanguage === "en" || savedLanguage === "sr" ? savedLanguage : "sr";

i18n.use(initReactI18next).init({
    resources: {
        sr: { login: srLogin },
        en: { login: enLogin },
    },
    lng: initialLanguage,
    fallbackLng: "sr",
    defaultNS: "login",
    interpolation: {
        escapeValue: false,
    },
});

if (typeof document !== "undefined") {
    document.documentElement.lang = initialLanguage;
}

export default i18n;
